<div *transloco="let t">
  <div
    [appDropdownTriggerFor]="dropdown"
    (overlayClosed)="onToggleDropdown($event)"
    [matTooltip]="groupSelectorTooltip"
  >
    <div class="group-picker" [ngClass]="!groupTab ? 'dropdown--enabled' : 'dropdown-disabled'">
      <div class="group-picker__text-wrapper">
        <ng-content *ngTemplateOutlet="tCurrentGroup"></ng-content>
      </div>

      <div [ngClass]="dropdownOpen ? 'group-picker__arrow--open' : 'group-picker__arrow--closed'">
        <xi-icon icon="single_arrow_down"></xi-icon>
      </div>
    </div>
  </div>

  <app-account-dropdown #dropdown>
    @if (!groupTab) {
      <div class="group-picker">
        <ng-content *ngTemplateOutlet="tCurrentGroup"></ng-content>
        <div [@arrowState]="state">
          <xi-icon icon="single_arrow_down"></xi-icon>
        </div>
      </div>
      <div class="border-divider"></div>
      <div class="dropdown-open">
        @for (group of groups; track group) {
          <div>
            <div
              [ngClass]="{
                'dropdown-open__button kxi-text-small': group !== selectedGroup,
                'dropdown-open__button__selected kxi-text-small': group === selectedGroup,
              }"
              role="button"
              (click)="setGroup(group)"
              [matTooltip]="group.group_name"
              [matTooltipPosition]="'left'"
              [matTooltipDisabled]="group.group_name.length < 25"
            >
              {{ group.group_name | truncateEnd: 25 }}
              @if (group === selectedGroup) {
                <xi-icon icon="circle_check_filled" color="CX"></xi-icon>
              }
            </div>
            <div class="border-divider"></div>
          </div>
        }
      </div>
    }
  </app-account-dropdown>

  <ng-template #tCurrentGroup>
    <div class="group-picker__text-wrapper">
      <p class="kxi-text-medium kxi-text-600 group-picker__text">
        {{ selectedGroupName }}
      </p>

      <p class="kxi-text-xsmall group-picker__text">
        {{ t('group-dropdown-wrapper.user-group') }}
      </p>
    </div>
  </ng-template>
</div>
